// extracted by mini-css-extract-plugin
export default {"checkBox":"CheckboxesDiagram_checkBox__O1U+b","text":"CheckboxesDiagram_text__yqXhS"};